import { Injectable } from '@angular/core';

@Injectable()
export class DashboardData {

    private _data:any = {};

    public set data(data: any) {
        this._data = Object.assign(this._data, data);
    }

    public get data(): any {
        return this._data;
    }
}



// WEBPACK FOOTER //
// ./src/services/dashboard-data.ts